window.$ = require('jquery');
$(function () {
    window.dataLayer = window.dataLayer || [];

    function pushModalEvent(data) {
      try {
        window.dataLayer.push(data);
        console.log('[Modal Analytics]', data);
      } catch (err) {
        console.warn('[Modal Analytics] Failed to push:', err);
      }
    }

    // --- Core Analytics Binding ---
    function initModalAnalytics() {
      var modal = $('#newsletter-modal');
      var thankYouModal = $('#thank-you-modal');
      var form = $('#newsletter-form');
      var noThanksBtn = $('.not-interested-btn');
      var closeBtns = $('.close-modal');
      var continueBtn = $('.continue-shopping-btn');

      if (!modal.length || !form.length) {
        return false; // modal not yet in DOM
      }

      console.log('[Modal Analytics] Binding events');

      // Modal Viewed
      pushModalEvent({
        event: 'modal_viewed',
        interaction_type: 'optin modal viewed',
        modal_name: 'newsletter_signup'
      });

      // First Interaction
      form.one('focusin', function () {
        pushModalEvent({
          event: 'modal_first_interaction',
          interaction_type: 'optin modal first interaction',
          modal_name: 'newsletter_signup'
        });
      });

      // Form Submitted
      form.on('submit', function () {
        pushModalEvent({
          event: 'modal_form_submitted',
          interaction_type: 'optin modal form submitted',
          modal_name: 'newsletter_signup'
        });
      });

      // No Thanks Clicked
      noThanksBtn.on('click', function () {
        pushModalEvent({
          event: 'modal_dismissed',
          interaction_type: 'optin modal dismissed',
          modal_name: 'newsletter_signup'
        });
      });

      // Close Modal
      closeBtns.on('click', function () {
        pushModalEvent({
          event: 'modal_closed',
          interaction_type: 'optin modal closed',
          modal_name: 'newsletter_signup'
        });
      });

      // Thank You Modal Viewed
      if (thankYouModal.length) {
        var observer = new MutationObserver(function () {
          if (thankYouModal.css('display') === 'flex') {
            pushModalEvent({
              event: 'thankyou_modal_viewed',
              interaction_type: 'thank you modal viewed',
              modal_name: 'newsletter_signup'
            });
          }
        });
        observer.observe(thankYouModal[0], { attributes: true, attributeFilter: ['style'] });
      }

      // Continue Browsing Clicked
      continueBtn.on('click', function () {
        pushModalEvent({
          event: 'thankyou_continue_browsing',
          interaction_type: 'thank you modal continue browsing clicked',
          modal_name: 'newsletter_signup'
        });
      });

      return true;
    }

    // --- Watch for Modal Insertion ---
    var modalCheckInterval = setInterval(function () {
      var found = initModalAnalytics();
      if (found) {
        clearInterval(modalCheckInterval);
        console.log('[Modal Analytics] Initialized successfully');
      }
    }, 1000); // checks every 1s until modal exists
});